export class FixConversation {
  private readonly party1: string | null;
  private readonly party2: string | null;
  private readonly name: string;

  /**
   * @param party1
   * @param party2
   * @param name
   * @constructor
   */
  constructor(party1: string | null, party2: string | null, name?: string) {
    this.party1 = party1;
    this.party2 = party2;
    if (name === undefined || name === null) {
      this.name = `${party1} <-> ${party2}`;
    } else {
      this.name = name;
    }
  }

  /**
   * @override
   * @returns {string}
   */
  toString(): string {
    return this.name;
  }
}
